/**
 * Словарь меток для полей заявки
 * Используется для отображения названий полей заявки в UI
 * Сгенерирован на основе installRequestFields
 */
export const REQUEST_FIELD_LABELS: Record<string, string> = {
  // Основные поля заявки
  requestNumber: 'Номер заявки (уникальный)',
  projectNumber: 'Номер проекта (может быть договор)',
  ownerProjectNumber: 'Внутренний номер проекта',

  // Документы
  pts: 'Серия и номер ПТС',
  psm: 'Серия и номер ПСМ',
  pl_timeOfTransfer: 'Срок передачи ПЛ',
  supplyContract_num: 'Номер договора поставки',
  supplyContract_dateLLL: 'Дата договора поставки',
  supplyContract_date: 'Дата договора поставки',
  dkp_point_link: 'Ссылка на пункт ДКП',
  dkp_act_copies: 'Кол-во экземпляров Акта к ДКП',
  templateType: 'Тип документа (ПТС, ПСМ, ОБР)',

  // Адреса и контакты
  balance_holder: 'Балансодержатель(род.падеж)',
  shipmentDocsAddress: 'Адрес отправки оригиналов документов',
  shipmentKeysAddress: 'Адрес отправки ключей',
  nearestBranch: 'Ближайший филиал заказчика',

  // Даты выдачи
  releaseDateLLL: 'Дата выдачи',
  releaseDate: 'Дата выдачи',
  releaseTime: 'Время выдачи',
  releaseDateTimeLLL: 'Дата и время выдачи',
  releaseDateTime: 'Дата и время выдачи',

  // Специалист по сопровождению
  installer_lastNameAndInc: 'Фамилия и инициалы специалиста по сопровождению',
  installer_fio_rod: 'ФИО специалиста по сопровождению(род.падеж)',
  installer_fio: 'ФИО специалиста по сопровождению',
  installer_post: 'Должность специалиста по сопровождению',
  installer_rulesBasis_rod:
    'Основание полномочий специалиста по сопровождению(род.падеж)',
  installer_dover_date: 'Дата доверенности специалиста по сопровождению',
  installer_dover_num: 'Номер доверенности специалиста по сопровождению',
  installer_phone: 'Телефон специалиста по сопровождению',

  // Лизингополучатель
  subjName: 'Наименование лизингополучателя (короткое)',
  subjInn: 'ИНН лизингополучателя',
  subjFullname: 'ФИО лизингополучателя',
  subjPhone: 'Телефон лизингополучателя',
  subjAddress: 'Адрес лизингополучателя',
  subjOfficialAddress: 'Юридический адрес лизингополучателя',
  subjInitials: 'Инициалы лизингополучателя',

  // Полное наименование лизингополучателя
  lp_fullname: 'Полное наименование лизингополучателя',
  lp_lastname: 'Фамилия лизингополучателя',
  lp_inc: 'Инициалы лизингополучателя',
  lp_fio_rod: 'ФИО лизингополучателя(род.падеж)',
  lp_post: 'Должность лизингополучателя',
  lp_post_rod: 'Должность лизингоплучателя(род.падеж)',
  lp_rulesBasis_rod: 'Основание полномочий лизингополучетеля(род.падеж)',
  lp_dover_dateLLL: 'Дата доверености лизиногополучетеля',
  lp_dover_date: 'Дата доверености лизиногополучетеля',
  lp_dover_num: 'Номер доверенности лизиногополучетеля',
  lp_id_num_d: 'ID лизиногополучетеля- номер из договора',

  // Договор лизинга
  contract: 'Номер договора лизинга (короткий)',
  contractDateLLL: 'Дата договора лизинга',
  contractDate: 'Дата договора лизинга',
  contractPlannedEndDateLLL: 'Плановая дата окончания договора лизинга',
  contractPlannedEndDate: 'Плановая дата окончания договора лизинга',
  contractEarlyEndDateLLL: 'Дата досрочного окончания договора лизинга',
  contractEarlyEndDate: 'Дата досрочного окончания договора лизинга',
  postav_dl_contract_full: 'Полный номер договора лизинга',

  // Транспортное средство
  carBrandId: 'Марка ТС (ID)',
  carModelAndBrand: 'Марка, модель ТС',
  carBrandName: 'Марка ТС (Наименование)',
  carModel: 'Модель ТС',
  carType: 'Тип ТС',
  carVin: 'VIN',
  carVinNumber: 'Номер кузова',
  carYear: 'Год выпуска ТС',
  carName: 'Наименование ТС',
  carEngine: 'Двигатель',
  carChassis: 'Шасси',
  carColor: 'Цвет кузова',
  carEnginePower: 'Мощность двигателя',
  carEngineVolume: 'Объем двигателя',
  carPtsDateLLL: 'Объект лизинга ПТС Дата',
  carPtsDate: 'Объект лизинга ПТС Дата',
  carPtsDateOfIssue: 'Объект лизинга ПТС Выдан',
  carPlantNumber: 'Заводской номер',
  carTransmissionNum: 'Коробка передач номер',
  carAxleNum: 'Ведущий мост номер',
  carMaxSpeed: 'Максимальная скорость',
  carCategory: 'Категория ТС',
  carEngineNumber: 'Номер двигателя',
  carMaxWeight: 'Максимальная масса',
  carIsNew: 'Новое авто?',
  weightWithoutLoad: 'Масса',

  // Адрес выдачи
  deliveryName: 'Название салона выдачи ПЛ',
  deliveryAddress: 'Адрес салона выдачи ПЛ',
  releaseAddress: 'Адрес выдачи ПЛ',
  deliveryPersonName: 'Контактое лицо в салоне',
  deliveryPersonPhone: 'Телефон контактного лица в салоне',
  deliveryPersonEmail: 'Email контактного лица в салоне',
  actualDeliveryAddress: 'Точный адрес выдачи',
  deliveryAddress_index: 'Адрес выдачи ПЛ: индекс',
  deliveryAddress_region: 'Адрес выдачи ПЛ: область',
  deliveryAddress_city: 'Адрес выдачи ПЛ: город',
  deliveryAddress_street: 'Адрес выдачи ПЛ: улица',
  deliveryAddress_house: 'Адрес выдачи ПЛ: дом',

  // Поставщик
  postav_inn: 'ИНН поставщика',
  postav_lastnameAndInc: 'Фамилия и инициалы поставщика',
  postav_name: 'Наименование поставщика (краткое)',
  postav_name_full: 'Полное наименование поставщика',
  postav_post: 'Должность поставщика',
  postav_post_rod: 'Должность поставщика(род.падеж)',
  postav_fio_rod: 'ФИО поставщика(род.падеж)',
  postav_rulesBasis_rod: 'Основание полномочий поставщика(род.падеж)',
  postav_dover_date: 'Дата доверености поставщика',
  postav_dover_dateLLL: 'Дата доверености поставщика',
  postav_dover_num: 'Номер доверенности поставщика',
  postav_phone: 'Телефон поставщика',
  supplier_OGRN: 'Поставщик ОРГН',
  supplier_KPP: 'Поставщик КПП',

  // Финансовые данные
  VAT_sum: 'НДС сумма',
  summWith_VA: 'Сумма с учетом НДС',
  PK_buyer_shor: 'ПК_Покупатель кратное наименование',
  PK_buyer_legalAddress: 'ПК_Покупатель юридический адрес',
  PK_inn_dl_buyer: 'ПК_ИНН ДЛ/Покупателя',
  PK_kpp_branch: 'ПК_КПП филиала',

  // Плательщик - ГП
  GP_payerBranchNam: 'ГП_Наименование филиала плательщика',
  GP_pbRegistrationAddres: 'ГП_Адрес регистрации филиала',
  GP_payerInn: 'ГП_ИНН плательщика',
  GP_payerGpp: 'ГП_КПП Плательщика',

  // Плательщик - ПЛ
  PL_payerBranchNam: 'ПЛ_Наименование филиала плательщика',
  PL_pbRegistrationAddres: 'ПЛ_Адрес регистрации плательщика',
  PL_payerInn: 'ПЛ_ИНН плательщика',
  PL_payerGpp: 'ПЛ_КПП плательщика',
  PL_bankName: 'ПЛ_Наименование банка',
  paySettlementAccoun: 'Расчетный счет',
  payBusinessAccoun: 'Корр.Счет Номер',
  BIC: 'БИК',

  // Дополнительные поля
  expectedNameOfP: 'Ожидаемое наименование ПЛ в ТН',
  cfo: 'ЦФО',
  problemGroup: 'Группа проблемности',
  currentMistakes: 'Текущая ошибка в заявке',
  manufacturerCompany: 'Предприятие изготовитель',
  engineType: 'Тип двигателя',
  manufacturerCountry: 'Страна изготовитель',

  // Партии
  ownerBatch: 'Номер партии',
  ownerNumberInBatch: 'Порядковый номер в партии',

  // Акты и документы
  useAlternativeAct: 'Использовать альтернативные акты',
  useOwnerAct: 'Использовать акты заказчика',
  transmittedDocs: 'Передаваемые документы',
  cancelReason: 'Причина отмены заявки',
  documentReleaseDateLLL: 'Дата документарной отгрузки',
  documentReleaseDate: 'Дата документарной отгрузки',

  // Персонал
  clientManagerGroupHead: 'Руководитель группы КМ',
  sellDepartment: 'Подразделение продаж',
  ownerLogistFullname: 'ФИО Логиста заказчика',
  ownerLogistPhone: 'тел. Логиста заказчика',
  supportOsAccountant: 'Бухгалтер по учету ОС',

  // ПТС типы
  ptsSubtype: 'Тип ПТС',
  transportCategoryCode: 'E_PTS: Код категории транспорта',
  E_PTS_EngineMark: 'E_PTS: Марка двигателя',
  E_PTS_Enginetype: 'E_PTS: Тип двигателя',
  E_PTS_DestName:
    'E_PTS: Наименование транспортного средства, определяемое его назначением',
  E_PTS_Category: 'E_PTS: Категория в соответствии с Конвенцией о движении',
  E_PTS_EcoClass: 'E_PTS: Экологический класс',

  // Прочие поля
  areaCode: 'Код субьекта (Регион)',
  inventoryDocUploaded: 'Опись подгружена?',
  kladr: 'Код по КЛАДР',
  inventoryNumber: 'Инвентарный номер',
  insuranceVendor: 'Название страховой компании',
  obdStatus: 'Диагностический разьем',
  leasingProduct: 'Лизинговый продукт',
  extendedProgram: 'Расширение программы',
  timezone: 'Часовой пояс',
  devicesSettingsProfileForceId: 'Id профиля настроек устройств',
  inspectionResult: 'Осмотр предмета лизинга',
  hasEDO: 'Электронный документооборот',
  paymentOrderAndDate: 'Номер и дата платежного поручения',

  // Системные поля
  lesseeSigningDate: 'Дата подпиания с ЛП',
  completedAt: 'Дата завершения',
  releasedAt: 'Дата выдачи',
  actualReleaseDate: 'Фактическая дата выдачи',
  releaseDateUpdatedAt: 'Дата обновления даты выдачи',
  createdAt: 'Дата создания',
  updatedAt: 'Дата обновления',
};

/**
 * Получает метку для поля заявки
 * @param fieldName - Название поля заявки
 * @returns Метка для отображения или само название поля, если метка не найдена
 */
export function getRequestFieldLabel(fieldName: string): string {
  return REQUEST_FIELD_LABELS[fieldName] || fieldName;
}
